@if (dataContext) {
  <form class="action-form astral-dialog-form astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
    <h4>{{ 'LEASE_AGREEMENT_DOCUMENT.FORM_HEADER' | translate }}</h4>
    <p>{{ 'COMMON.PROPERTY' | translate }}: {{ dataContext.propertyName }}</p>
    <app-single-file-upload (filesSelected)="onFileChange($event)"></app-single-file-upload>
    <astral-layout-group [columns]="2" [tabletColumns]="2" [mobileColumns]="1">
      <astral-input [control]="form.controls['caption']"></astral-input>
      <astral-select [control]="form.controls['connectionType']" [itemsSource]="connectionTypes"></astral-select>
    </astral-layout-group>
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" label="OK"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
